import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import Carousel from './Carousel'

const ProjectContent = ({ project, suffix }) =>
  <article>
    {
      project.images.length > 1
      ? <Carousel images={project.images} />
      : <img className="img-fluid w-100" src={project.images[0]} />
    }

    <div className="t-spacing px-3 py-4 p-sm-5 p-lg-4 p-xl-5">
      <header className="mb-5">
        <h6 className="text-primary text-uppercase mb-3">
          {[
            project.type.split('-').map(word =>
              word[0].toUpperCase() + word.slice(1)
            ).join(' '),
            suffix,
          ].filter(Boolean).join(' — ')}
        </h6>

        <p className="text-black-50">
          <FontAwesomeIcon icon="map-marker-alt" fixedWidth />
          {' '}
          <i>{project.location}</i>
        </p>

        <h1>{project.name}</h1>

        <hr className="border-primary hr-thicc" />
      </header>

      <div className="text-black-50">
        {project.description.split('\n\n').map((p, i) => <p key={i}>{p}</p>)}
      </div>
    </div>
  </article>

export default ProjectContent
